<template>
  <div :style="{...wrapStyle}" @click="handleClickEvent()">
    <p :class="getCss('bind-btn-text')" :style="btnTextStyle" @click="handleButtonClick()">{{ btnText }}</p>
    <modal :isShow="isShow" v-transfer-dom>
      <div :class="getCss('modal')" :style="modalStyle">
        <div :class="getCss('btn-close')" :style="closeStyle" @click="closeDialog()">×</div>
        <div :class="getCss('head_text')" :style="titleStyle">{{ btnText }}</div>
        <!-- 未绑定 -->
        <template v-if="step === 1">
          <input
            type="text"
            :class="getCss('qq-input')"
            :style="inputStyle"
            v-model="currentName"
            placeholder="请填写姓名"
          />
          <p
            :class="getCss('tip')"
            :style="tipStyle"
          >{{ configurationData.modalConfig.submitBtnConfig.msg }}</p>
          <a
            href="javascript:void(0);"
            :class="getCss('modal-fotter-center-btn')"
            :style="submitBtnStyle"
            @click="submit()"
          ></a>
        </template>
        <!-- 二次确认 -->
        <template v-if="step === 2">
          <input
            type="text"
            :class="getCss('qq-input')"
            :style="inputStyle"
            v-model="currentName"
            disabled
            placeholder="请填写姓名"
          />
          <p :class="getCss('tip')" :style="tipStyle">绑定姓名仅限一次，请确认提交的姓名是否正确</p>

          <div :class="getCss('modal-fotter-control')" :style="confirmControlStyle">
            <a
              href="javascript:void(0);"
              :class="getCss('modal-fotter-control-btn')"
              :style="confirmControlLeftStyle"
              @click="confirm()"
            ></a>
            <a
              href="javascript:void(0);"
              :class="getCss('modal-fotter-control-btn')"
              :style="confirmControlRightStyle"
              @click="closeDialog()"
            ></a>
          </div>
        </template>
        <!-- 已绑定 -->
        <template v-if="step === 3">
          <p :class="getCss('tip')" :style="inputTipStyle">已绑定:{{ currentName }}</p>
          <p :class="getCss('tip')" :style="tipStyle">绑定姓名仅限一次</p>
          <a
            href="javascript:void(0);"
            :class="getCss('modal-fotter-center-btn')"
            :style="doneBtnStyle"
            @click="closeDialog()"
          ></a>
        </template>
      </div>
    </modal>
    <c-dialog
      v-model="showSubscribeDlg"
      :option="subscribeOption"
      @close="closeSubscribeDlg"
      v-transfer-dom
    >
      <template slot="body">
        <div :class="getCss('subscribe-dialog')">
          <div :class="getCss('subscribe-dialog-title')" :style="styles.subscribeDlgTitle" v-html="subscribeTitle">
          </div>
          <div
            :class="getCss('subscribe-dialog-QRcode')"
            :style="subscribeDlgQRcodeStyle"
            @touchstart="subscribeDlgTouchstart()"
            @touchend="subscribeDlgTouchend()"
            @touchmove="subscribeDlgTouchmove()"
          >
            <img v-if="isQQ || isWX" :src="configurationData.subscribeDlgQRImg" :style="subscribeDlgQRcodeImgStyle" />
          </div>
          <div :class="getCss('subscribe-dialog-text')" :style="styles.subscribeDlgText" v-html="subscribeText"></div>
        </div>
      </template>
    </c-dialog>
  </div>
</template>
<script>
import '@tencent/ceiba-base-components/index.scss';
import { baseComponents, componentBaseMixin } from '@tencent/ceiba-base-components';
import CDialog from '@tencent/ceiba-base-components/src/components/ceiba-dialog';
import modal from './modal.vue';
import common from '@tencent/ceiba-base-components/src/common';

// 按钮展示状态
const DEFAULT_BUTTON_TYPE = 1;// 默认按钮
const FILL_NAME_BUTTON_TYPE = 2;// 绑定姓名按钮
const RET_PACKET_BIND_REDIRECT_BUTTON_TYPE = 3;// 红包绑定微信跳转按钮
const SUBSCRIBE_BIND_REDIRECT_BUTTON_TYPE = 4;// 关注公众号绑定微信跳转按钮
const SUBSCRIBE_BUTTON_TYPE = 5;// 关注公众号按钮

const SUCCESS_STATUS = 0;// 成功的状态
const NO_SUBSCRIBE_STATUS = 10100;// 未关注公众号
const NO_BIND_STATUS = 10101;// 未绑定微信
const NO_FILL_NAME_STATUS = 10102;// 未绑定姓名

export default {
  name: 'CPopupBindName',
  components: {
    [CDialog.name]: CDialog,
    modal,
  },
  mixins: [componentBaseMixin],
  data() {
    return {
      cssPrefix: 'popup-bind-name-',
      isShow: false,
      currentName: '',
      currentWX: '',
      step: 1,
      packageRedPacketFlowId: 0,
      showSubscribeDlg: false,
      subscribeDlgTextList: this.configurationData?.subscribeDlgTextList || [{}],
      subscribeDlgTouchLoop: 0, // 订阅弹窗长按事件
    };
  },
  computed: {
    subscribeOption() {
      const subscribeDlgBgImg = !!this.configurationData.subscribeDlgBgImg ? `url('${this.configurationData?.subscribeDlgBgImg}')` : this.dialogConfig.dialogStyle.backgroundImage;
      return Object.assign({}, this.dialogConfig, {
        header: false,
        footer: false,
        close: true,
        bodyStyle: {
          overflow: 'hidden',
          alignItems: 'flex-start',
          flexDirection: 'column',
        },
        cancel: false,
        confirm: false,
        dialogStyle: {
          backgroundImage: subscribeDlgBgImg,
        },
      });
    },
    // 公众号弹窗,需要使用app分享功能的情况
    needUseAppShare() {
      const textConfig = this.subscribeDlgTextList[0];
      // 在助手类app中,并且配置了助手分享
      const inHelper = textConfig.helperShare && typeof window.GameHelper !== 'undefined'
        && typeof window.GameHelper.shareWebPage !== 'undefined';
      // 在心悦或闪现app内
      const needShareApp = this.$ast.isAPP()
        && (this.$ast.currentAstName() === 'TGCLUB' || this.$ast.currentAstName() === 'SPARK');

      return inHelper || needShareApp;
    },
    // 二维码弹窗标题
    subscribeTitle() {
      const textConfig = this.subscribeDlgTextList[0];
      if (this.isQQ) {
        return textConfig.QQTittle;
      }
      if (this.isWX) {
        return textConfig.WXTittle;
      }
      if (this.needUseAppShare) {
        return textConfig.appShareTittle;
      }
      return textConfig.otherTittle;
    },
    // 二维码弹窗文案
    subscribeText() {
      const textConfig = this.subscribeDlgTextList[0];
      if (this.isQQ) {
        return textConfig.QQText;
      }
      if (this.isWX) {
        return textConfig.WXText;
      }
      if (this.needUseAppShare) {
        return textConfig.appShareText;
      }
      return textConfig.otherText;
    },
    subscribeDlgQRcodeStyle() {
      return {
        background: `url(${this.configurationData.subscribeDlgQRImg}) no-repeat center/contain`,
      };
    },
    subscribeDlgQRcodeImgStyle() {
      return {
        width: '100%',
        height: '100%',
      };
    },
    wrapStyle() {
      return {
        ...this.styles.base,
      };
    },
    btnTextStyle() {
      return {
        ...this.styles.fontStyle,
        color: this.configurationData.btnColor,
        textAlign: 'center',
        lineHeight: 'inherit',
      };
    },
    modalStyle() {
      return {
        width: `${this.configurationData.modalConfig.backgroundConfig.width}rem`,
        height: `${this.configurationData.modalConfig.backgroundConfig.height}rem`,
        color: this.configurationData.titleColor,
        backgroundImage: `url(${this.configurationData.modalConfigBackgroundConfigImg})`,
        backgroundRepeat: 'no-repeat',
      };
    },
    submitBtnStyle() {
      return {
        width: `${this.configurationData.modalConfig.submitBtnConfig.width}rem`,
        height: `${this.configurationData.modalConfig.submitBtnConfig.height}rem`,
        top: `${this.configurationData.modalConfig.submitBtnConfig.top}%`,
        background: `url(${this.configurationData.modalConfigSubmitBtnConfigImg}) no-repeat center/contain`,
      };
    },
    confirmControlStyle() {
      return {
        top: `${this.configurationData.modalConfig.confirmBtnConfig.top}%`,
      };
    },
    confirmControlLeftStyle() {
      return {
        width: `${this.configurationData.modalConfig.confirmBtnConfig.width}rem`,
        height: `${this.configurationData.modalConfig.confirmBtnConfig.height}rem`,
        background: `url(${this.configurationData.modalConfigConfirmBtnConfigleftImg}) no-repeat center/contain`,
      };
    },
    confirmControlRightStyle() {
      return {
        width: `${this.configurationData.modalConfig.confirmBtnConfig.width}rem`,
        height: `${this.configurationData.modalConfig.confirmBtnConfig.height}rem`,
        background: `url(${this.configurationData.modalConfigConfirmBtnConfigrightImg}) no-repeat center/contain`,
      };
    },
    doneBtnStyle() {
      return {
        width: `${this.configurationData.modalConfig.doneBtnConfig.width}rem`,
        height: `${this.configurationData.modalConfig.doneBtnConfig.height}rem`,
        top: `${this.configurationData.modalConfig.doneBtnConfig.top}%`,
        background: `url(${this.configurationData.modalConfigDoneBtnConfigImg}) no-repeat center/contain`,
      };
    },
    inputStyle() {
      return {
        width: `${this.configurationData.modalConfig.inputConfig.width}rem`,
        height: `${this.configurationData.modalConfig.inputConfig.height}rem`,
        lineHeight: `${this.configurationData.modalConfig.inputConfig.height}rem`,
        top: `${this.configurationData.modalConfig.inputConfig.top}%`,
        color: this.configurationData.inputColor,
        borderColor: this.configurationData.modalConfig.inputConfig.color,
        background: this.configurationData.modalConfig.inputConfig.backgroundColor,
      };
    },
    tipStyle() {
      return {
        width: `${this.configurationData.modalConfig.inputConfig.width}rem`,
        color: this.configurationData.textColor,
      };
    },
    inputTipStyle() {
      return {
        fontSize: '0.35rem',
        width: `${this.configurationData.modalConfig.backgroundConfig.width}rem`,
        height: `${this.configurationData.modalConfig.backgroundConfig.height}rem`,
        top: `${this.configurationData.modalConfig.inputConfig.top}%`,
        color: this.configurationData.textColor,
      };
    },
    titleStyle() {
      return {
        ...this.styles.fontStyle,
        color: this.configurationData.titleColor,
      };
    },
    closeStyle() {
      return {
        color: this.configurationData.modalConfig.closeConfig.color,
      };
    },
    btnText() { // 文字内容
      return this.configurationData.btnText;
    },
    accType() {
      return common.tool.getCookie('acctype');
    },
    isWX() {
      return common.platform.isWX;
    },
    isQQ() {
      return common.platform.isQQ;
    },
  },
  mounted() {
    console.log('configurationData=', this.configurationData);
    const self = this;
    // 当抽中红包时，点击领取红包按钮未绑定姓名时拉起绑定姓名弹窗
    this.$eventBus.$on('ceiba:common:event:form-fill-name', () => {
      this.queryBindName();
      self.showDialog();
    });
    // 领取红包事件
    this.$eventBus.$on('ceiba:common:events:rewardRedPacket', async (item) => {
      this.packageId = item?.gift_id;

      this.checkGiftType('redPacket');
      console.log('ceiba:common:events:rewardRedPacket:', item);

      const newSerialId = item?.req_serial;
      const response = await this.flowRequest({
        flowId: this.packageRedPacketFlowId,
        params: {
          role: this.roleInfo,
          data: JSON.stringify({
            sSerialId: newSerialId,
          }),
        },
      });

      if (response?.ret) {
        return this.$toast(response?.msg || '领取失败，请稍后重试~');
      }

      if (response?.ret && response?.msg === String(NO_BIND_STATUS)) {
        // QQ登录领取红包，未绑定微信去跳转授权
        this.$eventBus.$emit('ceiba:common:events:redpacket-bindqq', {});
        return;
      }
      if (response?.ret && response?.msg === String(NO_FILL_NAME_STATUS)) {
        // 拉起绑定姓名弹窗
        this.$eventBus.$emit('ceiba:common:event:form-fill-name');
        return;
      }

      if (response?.data?.ret) {
        return this.$toast(response?.data?.msg || '领取失败，请稍后重试~');
      }

      // 未绑定微信名称 bindStatus 0:绑定，10102：未绑定微信名称，10101：未绑定QQopenid
      if (response?.data?.bindStatus) {
        // QQ登录领取红包，未绑定微信去跳转授权
        if (response?.data?.bindStatus === NO_BIND_STATUS) {
          this.$eventBus.$emit('ceiba:common:events:redpacket-bindqq', {});
          return;
        }
        if (response?.data?.bindStatus === NO_FILL_NAME_STATUS) {
          // 拉起绑定姓名弹窗 @tencent/ceiba-act-public-button-lottery
          this.$eventBus.$emit('ceiba:common:event:form-fill-name');
          return;
        }
        return;
      }
      // 已绑定微信名称
      this.isShow = false;
      return this.$alert({
        msg: response?.data?.msg ||  '红包领取成功',
      });
    });
    // 当抽中红包时，QQ登录未绑定微信去跳转授权
    this.$eventBus.$on('ceiba:common:events:redpacket-bindqq', () => {
      this.bindRedirectURL();
    });
    // 监听关注公众号事件
    this.$eventBus.$on('ceiba:common:events:subscribe-gongzhonghao', () => {
      this.handlerSubscribe();
    });
    this.configurationData.backgroundImage ? this.btnText = '' : '';
    this.initialize();
  },
  methods: {
    initialize() {
      this.$onLogined(() => {
        if (this.getSubscribeBindRedirectLocalStorage() === this.uid) {
          this.handlerSubscribe({ isFromBindRedirect: true });
        }
      });
    },
    preCheck({ forceLogin = true, forceRole = true } = {}) {
      // 强制登陆
      if (forceLogin) {
        if (!this.isLogin) {
          baseComponents.userLoginComponent.login();
          return false;
        }
      }
      // 检测角色绑定
      if (forceRole) {
        if (this.configurationData.needRole && !this.isRoleReady && this.isRoleStatusValid) {
          this.alert({
            msg: '未检测到角色，请先绑定角色',
            confirm: () => {
            },
          });
          return false;
        }
      }
      return true;
    },
    handleButtonClick() {
      if (this.$isInEditor) return;
      this.handleClickEvent();
      // buttonType = FILL_NAME_BUTTON_TYPE 兼容旧版本组件
      const { buttonType = FILL_NAME_BUTTON_TYPE } = this.configurationData;
      console.log('【CPopupBindName】 handleButtonClick buttonType= ', buttonType);
      // 默认，点击无逻辑
      if (buttonType === DEFAULT_BUTTON_TYPE) {
        // default button, do nothing
      }
      // 点击按钮填写姓名
      if (buttonType === FILL_NAME_BUTTON_TYPE) {
        if (!this.preCheck({ forceLogin: true, forceRole: true })) return;
        this.queryBindName();
        this.showDialog();
      }
      // 点击按钮跳转授权【红包】
      if (buttonType === RET_PACKET_BIND_REDIRECT_BUTTON_TYPE) {
        if (!this.preCheck({ forceLogin: true, forceRole: true })) return;
        this.bindRedirectURL();
      }
      // 点击按钮跳转授权【关注公众号】
      if (buttonType === SUBSCRIBE_BIND_REDIRECT_BUTTON_TYPE) {
        if (!this.preCheck({ forceLogin: true, forceRole: false })) return;
        this.subscribeBindRedirectURL();
      }
      // 点击按钮引导关注公众号
      if (buttonType === SUBSCRIBE_BUTTON_TYPE) {
        if (!this.preCheck({ forceLogin: true, forceRole: false })) return;
        this.handlerSubscribe();
      }
    },
    // 查询到页面配置的抽奖后领取红包流程id
    checkGiftType(checkType) {
      const { packageId } = this;
      if (packageId === 0 || !packageId) return false;
      const receiveGiftCustomConfig = this.$actInfo?.extendConfig?.receiveGiftCustomConfig ?? [];
      const res = receiveGiftCustomConfig?.find(item => String(packageId).includes(item.gift_id));
      const { type = '' } = res || {};
      if (type === 'redPacket' && checkType === 'redPacket') {
        this.packageRedPacketFlowId = res?.playload?.packageRedPacketFlowId ?? '';
      }
    },
    async queryBindName() {
      const { checkFlowID } = this.configurationData;
      if (checkFlowID <= 0) return;
      const response = await this.flowRequest({
        flowId: checkFlowID,
        params: {
          data: JSON.stringify({
            form_tag: this.configurationData.formTag,
          }),
        },
      });
      console.log('查询', response);

      if (response.data.ret === 0) {
        try {
          const info = JSON.parse(response?.data?.info);
          const infoData = JSON.parse(info?.data);
          this.currentName = infoData?.name;
          if (this.currentName) {
            // 已经绑定
            this.step = 3;
          } else {
            this.step = 1;
          }
        } catch (error) {
          console.error('error', error);
        }
      }
    },
    showDialog() {
      this.isShow = true;
    },
    closeDialog() {
      console.log(this.isShow);
      if (this.step !== 3) {
        this.step = 1;
      }
      this.isShow = false;
    },
    submit() {
      // 微信号必须以字母或者下划线开头，可以使用6-20位数字、字母、下划线、减号或它们的组合
      // 发现有的微信号是以减号开头
      if (!this.currentName) {
        this.alert('请正确填写姓名');
        return false;
      }
      this.step = 2;
    },
    async confirm() {
      if (this.configurationData.isNeedInApp && !this.$ast.isAPP()) {
        this.$ast.gotoAPP();
        return false;
      }
      if (!this.configurationData.bindFlowID) {
        this.alert('绑定流程id未配置');
        this.reportClickRaw({
          ceibaComponentId: `${this.cid}`,
          ceibaComponentUid: this.uid,
          ceibaComponentUname: this.uname,
          eventKey: 'bind_name',
          eventData: {
            status: '0',
          },
        });
        return;
      }
      const response = await this.flowRequest({
        flowId: this.configurationData.bindFlowID,
        params: {
          data: JSON.stringify({
            questionnaire_data: JSON.stringify({ name: this.currentName }),
            form_tag: this.configurationData.formTag,
          }),
        },
      });
      if (response.data.ret === 0) {
        this.alert('绑定成功');
        this.closeDialog();
        this.step = 3;
        this.$eventBus.$emit('moudle.package.refresh');
        this.reportClickRaw({
          ceibaComponentId: `${this.cid}`,
          ceibaComponentUid: this.uid,
          ceibaComponentUname: this.uname,
          eventKey: 'bind_name',
          eventData: {
            status: '1',
          },
        });
      } else {
        this.step = 1;
        this.alert(response.msg);
        this.reportClickRaw({
          ceibaComponentId: `${this.cid}`,
          ceibaComponentUid: this.uid,
          ceibaComponentUname: this.uname,
          eventKey: 'bind_name',
          eventData: {
            status: '0',
          },
        });
      }
    },
    /**
     * 【关注公众号】记录绑定授权后需要前往关注公众号
     */
    setSubscribeBindRedirectLocalStorage() {
      localStorage.setItem(`act${this.actInfo.activity_id}SubscribeBindRedirectId`, this.uid);
    },
    getSubscribeBindRedirectLocalStorage() {
      return localStorage.getItem(`act${this.actInfo.activity_id}SubscribeBindRedirectId`);
    },
    removeSubscribeBindRedirectLocalStorage() {
      if (this.getSubscribeBindRedirectLocalStorage() === this.uid) {
        localStorage.removeItem(`act${this.actInfo.activity_id}SubscribeBindRedirectId`);
      }
    },
    /**
     * 前往关注公众号
     * 未授权绑定微信，引导前往绑定微信
     * @param isFromBindRedirect 是否从授权跳转链接进来
     * @returns {Promise<void>}
     */
    async handlerSubscribe({ isFromBindRedirect = false } = {}) {
      const {
        querySubscribeFlowId,
        subscribeConfirmJumpMsg = '是否前往关注公众号',
      } = this.configurationData;
      const response = await this.flowRequest({
        flowId: querySubscribeFlowId,
        params: {
          role: this.roleInfo,
        },
      });
      console.log('【CPopupBindName】handlerSubscribe query subscribe response = ', response);
      const { ret, msg, data } = response;
      if (ret !== 0) {
        this.$alert({ msg: msg || '查询失败' });
        return;
      }
      const { ret: resRet, msg: resMsg, bindStatus } = data;
      if (resRet !== 0 && resMsg !== String(NO_SUBSCRIBE_STATUS) && resMsg !== String(NO_BIND_STATUS)) {
        this.$alert({ msg: resMsg || '查询失败' });
        return;
      }
      // 跳转授权回来后处理逻辑，是否前往关注公众号
      if (isFromBindRedirect) {
        this.removeSubscribeBindRedirectLocalStorage();
        // 已关注公众号，就不再引导关注公众号了
        if (ret === 0 && bindStatus === SUCCESS_STATUS) return;
        const confirmSubscribeJump = () => {
          this.subscribe();
        };
        this.$confirm({
          confirm: confirmSubscribeJump,
          msg: subscribeConfirmJumpMsg,
          confirmText: '是',
          cancelText: '否',
        });
        return;
      }
      // 非跳转授权回来的逻辑，前往关注公众号
      // 未关注公众号
      // if (resRet !== 0 && resMsg === String(NO_SUBSCRIBE_STATUS) {}
      // QQ未绑定微信，引导授权绑定
      if (resRet !== 0 && resMsg === String(NO_BIND_STATUS)) {
        await this.subscribeBindRedirectURL({ isSetLocalStorageInWX: true });
        return;
      }
      // 未关注公众号
      // if (bindStatus === NO_SUBSCRIBE_STATUS) {}
      // QQ未绑定微信，引导授权绑定
      if (bindStatus === NO_BIND_STATUS) {
        await this.subscribeBindRedirectURL({ isSetLocalStorageInWX: true });
        return;
      }
      this.subscribe();
    },
    /**
     * 引导关注公众号
     */
    subscribe() {
      // 如果使用公众号二维码弹窗功能
      if (!!this.configurationData.useSubscribeDlg) {
        this.showSubscribeDlg = true;
        return;
      }
      const {
        subscribeLink = '',
        alertSubscribeMsg = '请前往微信客户端内参与活动',
        alertSubscribeInAppMsg = '请分享活动页面到微信客户端内参与',
        subscribeShareImage: shareImage,
      } = this.configurationData;
      if (!subscribeLink) {
        console.warn('【CPopupBindName】subscribe 微信公众号跳转链接为空');
        return;
      }
      console.log('【CPopupBindName】subscribe to jump');
      // 已绑定微信，引导去关注微信公众号
      // App内场景
      if (this.$ast.isAPP()) {
        this.$toast(alertSubscribeInAppMsg);
        this.callShareFunc({ shareUrlParams: {}, shareImage });
        return;
      }
      // QQ内场景（微信外场景），拉起分享（引导微信内参与）
      if (this.isQQ) {
        this.callShareFunc({ shareUrlParams: {}, shareImage });
        return;
      }
      // 微信外场景，引导微信内参与
      if (!this.isWX) {
        this.$alert({ msg: alertSubscribeMsg });
        return;
      }
      window.location.href = subscribeLink;
    },
    /**
     * 【关注公众号】QQ登录跳转授权绑定
     * @returns {Promise<void>}
     */
    async subscribeBindRedirectURL({ isSetLocalStorageInWX = false } = {}) {
      console.log('【CPopupBindName】subscribeBindRedirectURL isSetLocalStorageInWX = ', isSetLocalStorageInWX);
      const {
        subscribeConfirmRedirectBindMsg = '需要授权绑定微信后才能参与，是否前往授权？',
        subscribeAlertRedirectBindMsg = '未授权绑定微信，请前往微信客户端内打开活动页面，并且用QQ登录参与',
        subscribeAlertRedirectBindInAppMsg = '未授权绑定微信，请分享活动页面到微信客户端内参与',
        subscribeShareImage: shareImage,
      } = this.configurationData;
      // App内场景
      if (this.$ast.isAPP()) {
        this.$toast(subscribeAlertRedirectBindInAppMsg);
        await this.callShareFunc({ shareUrlParams: {}, shareImage });
        return;
      }
      // QQ内场景（微信外场景），QQ登录，拉起分享（引导微信内QQ登录参与）
      if (this.isQQ) {
        await this.callShareFunc({ shareUrlParams: {}, shareImage });
        return;
      }
      // 微信外场景，QQ登录，引导微信内QQ登录参与
      if (!this.isWX) {
        this.$alert({ msg: subscribeAlertRedirectBindMsg });
        return;
      }
      // 微信内场景，QQ登录，跳转授权
      const redirectURL = await this.queryBindRedirectURL();
      const confirmRedirect = () => {
        if (isSetLocalStorageInWX) {
          this.setSubscribeBindRedirectLocalStorage();
        }
        window.location.href = redirectURL;
      };
      this.$confirm({
        confirm: confirmRedirect,
        msg: subscribeConfirmRedirectBindMsg,
        confirmText: '是',
        cancelText: '否',
      });
    },
    /**
     * 【红包绑定授权】QQ登录跳转授权绑定
     * 微信登录不会走到这里
     * C_IS_RED_PACKET链接带红包标识，QQ登录才会带这字段
     * @returns {Promise<void>}
     */
    async bindRedirectURL() {
      const {
        confirmRedirectBindMsg = '需要授权绑定微信后才能参与，是否前往授权？',
        alertRedirectBindMsg = '未授权绑定微信，请前往微信客户端内打开活动页面，并且用QQ登录参与',
        alertRedirectBindInAppMsg = '未授权绑定微信，请分享活动页面到微信客户端内参与',
        shareImage,
      } = this.configurationData;
      // App内场景
      if (this.$ast.isAPP()) {
        this.$toast(alertRedirectBindInAppMsg);
        const shareUrlParams = {
          C_IS_RED_PACKET: 1,
        };
        await this.callShareFunc({ shareUrlParams, shareImage });
        return;
      }
      // QQ内场景（微信外场景），QQ登录，拉起分享（引导微信内QQ登录参与）
      if (this.isQQ) {
        const shareUrlParams = {
          C_IS_RED_PACKET: 1,
        };
        await this.callShareFunc({ shareUrlParams, shareImage });
        return;
      }
      // 微信外场景，QQ登录，引导微信内QQ登录参与
      if (!this.isWX) {
        this.$alert({ msg: alertRedirectBindMsg });
        return;
      }
      // 微信内场景，QQ登录，跳转授权
      const redirectURL = await this.queryBindRedirectURL();
      const confirmRedirect = () => {
        window.location.href = redirectURL;
      };
      this.$confirm({
        confirm: confirmRedirect,
        msg: confirmRedirectBindMsg,
        confirmText: '是',
        cancelText: '否',
      });
    },
    /**
     * 查询绑定微信的授权URL
     * @returns {Promise<void>}
     */
    async queryBindRedirectURL() {
      const { queryBindRedirectURLFlowId } = this.configurationData;
      if (queryBindRedirectURLFlowId <= 0) return;
      const { href: redirectURL } = window.location;
      const response = await this.flowRequest({
        flowId: queryBindRedirectURLFlowId,
        params: {
          role: this.roleInfo,
          data: JSON.stringify({ redirectURL }),
        },
      });
      console.log('CPopupBindName queryBindRedirectURL response = ', response);
      const { ret, data = {} } = response;
      if (ret !== 0) {
        return;
      }
      const { ret: resRet, url } = data;
      if (resRet !== 0) {
        return;
      }
      return url;
    },
    /**
     * 拉起分享
     * @param options
     */
    callShareFunc({ shareUrlParams = {}, shareImage = '' } = {}) {
      let link = this.shareConfig.link || window.location.href;
      const urlParamsKeys = Object.keys(shareUrlParams);
      for (const key of urlParamsKeys) {
        link = common.tool.setUrlParam(`${key}`, shareUrlParams[key], link);
      }
      // 当打开的活动url上携带了via,via_source,trace_id参数时，透传当前活动的via,via_source,trace_id到分享链接上
      link = common.tool.passThroughUrlParam(link, ['via', 'trace_id', 'via_source'], true);
      link = common.tool.setUrlParam('t', `${new Date().getTime()}`, link);
      const shareNewConfig = {
        title: this.shareConfig.title,
        link,
        desc: this.shareConfig.desc, // 分享标题，默认为活动页面标题（可手动调整）, //分享活动简介
        icon: this.shareConfig.icon, // 分享后朋友看到的图标
        shareImage, // 自定义分享蒙层
      };
      this.reportFunc('share', {});
      this.$ast.setAPPShare(shareNewConfig);
      if (this.$ast.isAPP()) {
        this.$ast.goAPPShare(shareNewConfig);
      } else {
        this.doShare(shareNewConfig);
      }
    },
    // 二维码图片长按拉起分享
    subscribeDlgTouchstart() {
      // 如果是支持分享app,拉起分享
      if (this.needUseAppShare) {
        this.subscribeDlgTouchLoop = setTimeout(() => {
          this.subscribeDlgTouchLoop = null;
          this.showImageShare();
        }, 800);
      }
      return false;
    },
    subscribeDlgTouchend() {
      clearTimeout(this.subscribeDlgTouchLoop);
      this.subscribeDlgTouchLoop = null;
      return false;
    },
    subscribeDlgTouchmove() {
      clearTimeout(this.subscribeDlgTouchLoop);
      this.subscribeDlgTouchLoop = null;
      return false;
    },
    closeSubscribeDlg() {
      this.showSubscribeDlg = false;
    },
    /**
     * 展示分享图片，app内拉起图片分享
     * @returns {Promise<void>}
     */
    async showImageShare() {
      try {
        const that = this;
        // app内图片分享
        if (that.$ast.isAPP()) {
          const url = that.configurationData?.subscribeDlgShareImage;
          switch (that.$ast?.currentAstName()) {
            case 'TGCLUB': {
              that.$ast?.setImageShare({ imageUrl: url });
              break;
            }
            case 'SPARK': {
              that.$ast?.setImageShare({ iconUrl: url });
              break;
            }
            case 'BB': {
              that.$ast?.setImageShare({ imgUrl: url });
            }
          }
          that.$ast?.imageShare();
        }
      } catch (error) {
        console.error('showImageShare fail, err = ', error);
      }
    },
    reportFunc(key, eventData) {
      if (typeof this.reportClickRaw === 'function') {
        const params = {
          ceibaComponentId: `${this.cid}`,
          ceibaComponentUid: this.uid,
          ceibaComponentUname: this.uname,
          eventKey: key,
          eventData,
        };
        this.reportClickRaw(params);
        console.log(`reportFunc ${key}  report data =`, params);
      }
    },
  },
};
</script>
<style lang="scss">
@import './styles.scss';
</style>
